import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React, { useEffect, useRef, useState } from 'react';

import { FiltersProps } from '../job-filters.component';
import '../job-filters.styles.scss';

export default function FilterTypes({ onFilter, status }: FiltersProps) {
  const [openMenu, setOpenMenu] = useState(false);
  const [checkedOptions, setCheckedOptions] = useState<string[]>([]);
  const menuRef = useRef<HTMLDivElement>(null);
  const submenuRef = useRef<HTMLDivElement>(null);
  const options = [
    'Full-time',
    'Part-time',
    'Internship',
    'Hybrid',
    'Contract',
  ];

  const handleClear = () => {
    setCheckedOptions([]);
    onFilter({ typeOfWork: [] });
  };

  useEffect(() => {
    handleClear();
  }, [status]);

  // General useEffect for handling clicks outside the dropdown
  useEffect(() => {
    const handleDocumentClick = (e: MouseEvent) => {
      const menu = menuRef.current as HTMLElement | null;
      if (
        menu &&
        e.target &&
        !(e.target as Element).closest('.filter-dropdown.type')
      ) {
        setOpenMenu(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  // logic for updating the list in jobBoard.tsx via updateList in services
  const handleCheck = (item: string) => {
    let checkedItems: string[] = checkedOptions;
    if (!checkedItems.includes(item)) {
      checkedItems.push(item);
    } else {
      const filteredItems = checkedItems.filter(
        (checkedItem) => checkedItem !== item,
      );
      checkedItems = filteredItems;
    }
    setCheckedOptions(checkedItems);

    if (checkedItems.length === 0) {
      onFilter({ typeOfWork: [] });
      return;
    }

    onFilter({ typeOfWork: checkedItems });
  };

  const toggleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    const menu = menuRef.current as HTMLElement | null;

    if (menu && e.target && !(e.target as Element).closest('.menuIcon')) {
      const menuPos = menu.getBoundingClientRect();

      if (menuPos && submenuRef.current) {
        submenuRef.current.style.left = menuPos.left + 'px';
      }
      setOpenMenu(!openMenu);
    }
  };

  return (
    <div className="filter-dropdown type" ref={menuRef}>
      <div
        className={'filter-btn ' + (openMenu ? 'open' : '')}
        onClick={(e) => toggleOpen(e)}>
        <span className="filter-btn-title">
          {checkedOptions.length === 0
            ? 'Job Type'
            : 'Job Type (' + checkedOptions.length + ')'}
          <FontAwesomeIcon
            icon={openMenu ? faChevronUp : faChevronDown}
            className="dropdownIcon"
          />
        </span>
        <FontAwesomeIcon
          icon={faXmark}
          className={
            'menuIcon ' + (checkedOptions.length !== 0 ? 'active' : '')
          }
          onClick={() => handleClear()}
        />
      </div>
      <div
        className={'filter-items ' + (openMenu ? 'open' : '')}
        ref={submenuRef}>
        <ul className="filterOptions">
          {options.map((item, index) => (
            <li className="filter-item" key={index}>
              <input
                type="checkbox"
                id={`types=${index.toString()}`}
                className="checkInput"
                value={item}
                checked={checkedOptions.includes(item) ? true : false}
                onChange={() => handleCheck(item)}></input>
              <label
                htmlFor={`types=${index.toString()}`}
                className="checkLabel">
                <div className="checkBox">
                  <FontAwesomeIcon icon={faCheck} className="checkIcon" />
                </div>
                <span>{item}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
